"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const mailbrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 51",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-mailbrand01` : '') + (description ? ` desc-mailbrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-mailbrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-mailbrand01"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.363 4.547h67.552V51H4.363V4.547Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F26B1C"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 .985C0 .441.441 0 .985 0h67.552c.545 0 .986.441.986.985v46.453a.985.985 0 0 1-.986.986H.985A.985.985 0 0 1 0 47.438V.985Zm1.97.985v44.483h65.582V1.97H1.97Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.982 12.818a.985.985 0 0 1 1.37-.26l24.41 16.655 24.41-16.654a.985.985 0 0 1 1.11 1.628L35.317 31.218a.985.985 0 0 1-1.11 0L9.24 14.186a.985.985 0 0 1-.259-1.368ZM20.92 29.897a.985.985 0 0 1-.336 1.352l-10.28 6.194a.985.985 0 0 1-1.016-1.688l10.28-6.193a.985.985 0 0 1 1.352.335ZM48.603 29.897a.985.985 0 0 1 1.352-.335l10.28 6.193a.985.985 0 0 1-1.017 1.688l-10.28-6.194a.985.985 0 0 1-.335-1.352Z"
  }))));
};
var _default = exports.default = mailbrand01;